import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const homeRedirectRoute: InvariantJiraRoute = {
	name: 'home-redirect',
	path: '/jira',
	exact: true,
};
